import 'mdn-polyfills/Array.prototype.find';
import {FallcoClass} from '../../../classes/FallcoClass';
import Bowser from 'bowser';

/**
 * Per testare i vari userAgent usare l'estensione di Chrome User-Agent Switch and Manager
 * https://chrome.google.com/webstore/detail/user-agent-switcher-and-m/bhchdcejhohfmigjafbampogmaanbfkg
 */

class BrowserDetector extends FallcoClass {
  constructor() {
    super();

    this._bowser  = Bowser.getParser(window.navigator.userAgent);
    this.instance = this._bowser;

    this._hackIOS13();

    return super.expose_to_public('browserDetector', this);
  }

  /**
   *
   * @param {string} userAgent
   * @returns {Bowser.Parser.Parser}
   */
  reloadUserAgent(userAgent) {
    this.instance = userAgent ? Bowser.getParser(userAgent) : this._bowser;

    this._hackIOS13();

    return this;
  }

  /**
   *
   * @param {{}} data
   * @param {string} userAgentString
   * @returns {boolean}
   */
  satisfies(data, userAgentString) {
    let bowserInstance = this.instance;

    if (userAgentString) {
      bowserInstance = Bowser.getParser(userAgentString);
    }

    return bowserInstance.satisfies(data);
  }

  /**
   * Determina se il browser attivo e' MS Internet Explorer, in caso affermativo ne ritorna il numero di versione,
   * diversamente FALSE
   * @return {Number|Boolean}
   */
  detectIE() {
    return this.info.browser.name.toLowerCase() === 'internet explorer';
  }

  /**
   * @deprecated
   * @returns {Number|Boolean}
   */
  detect_ie() {
    return this.detectIE();
  }

  /**
   * Determina se si tratta di un dispositivo iOS
   * @return {Boolean}
   */
  detectIOS() {
    return this.info.os.name.toLowerCase() === 'ios';
  }

  /**
   * @deprecated Use detectIOS()
   * @returns {Boolean}
   */
  detect_ios() {
    return this.detectIOS();
  }

  /**
   * Determina se si tratta di un browser mobile
   * @return {Boolean}
   */
  detectMobile() {
    return this.platform.toLowerCase() === 'mobile';
  }

  /**
   * @deprecated Use detectMobile()
   * @returns {Boolean}
   */
  detect_mobile() {
    return this.detectMobile();
  }

  detectSafari() {
    return this.info.browser.name.toLowerCase() === 'safari';
  }

  get isBootstrap4Compatible() {
    /**
     * @type {BowserSatisfiesSettings}
     */
    const satisfiesSettings = {
      mobile:  {
        safari:  '>=9',
        android: '>4.4'
      },
      tablet:  {
        safari:  '>=9',
        android: '>4.4'
      },
      chrome:  '>=45',
      firefox: '>=38',
      edge:    '>=12',
      ie:      '>=10.0',
      safari:  '>=9',
      opera:   '>=30'
    };

    return this.instance.satisfies(satisfiesSettings);
  }

  get isRecaptchaV3Compatible() {
    /**
     * @type {BowserSatisfiesSettings}
     */
    const satisfiesSettings = {
      mobile:  {
        safari:  '>=11', // rilasciato nel 2017 compatibile da iPhone 5S (2013)
        android: '>=6.0' // rilasciato nel 2015
      },
      tablet:  {
        safari:  '>=11', // rilasciato nel 2017 compatibile da iPad Air (2013)
        android: '>=6.0' // rilasciato nel 2015
      },
      chrome:  '>=45', // rilasciato nel 2015
      firefox: '>=38', // rilasciato nel 2015
      edge:    '>=15', // rilasciato nel 2016
      ie:      '>=11.0',
      safari:  '>=11', // rilasciato con OS X (version 10.11) nel 2015 compatibile con device dal 2008 in poi
      opera:   '>=32' // rilasciato nel 2015
    };

    return this.instance.satisfies(satisfiesSettings);
  }

  get info() {
    return this.instance.parsedResult;
  }

  get version() {
    return this.instance.getBrowserVersion();
  }

  get name() {
    return this.instance.getBrowserName();
  }

  get platform() {
    return this.instance.getPlatformType();
  }

  get os() {
    return this.instance.getOSName();
  }

  /**
   * Per iOS 13, siccome sembra che abbiano cambiato lo userAgent di safari, e quindi
   * la versione del browser coincide con quella del OS, se la versione del browser è vuota,
   * la setto uguale a quella del OS.
   * @private
   */
  _hackIOS13() {
    // Se il browser è Safari
    // Se non è settata la versione del browser
    if (this.detectSafari() && !this.version) {
      this.info.browser.version = this.info.os.version;
    }
  }

  get isFallcoAsteCompatible() {
    const satisfiesSettings = {
      chrome:  '>=90',
      edge: '>=90',
      firefox: '>=88',
      opera:   '>=76',
      ie:      '>=11.0',
      safari:  '>=14'
    };

    return this.instance.satisfies(satisfiesSettings);
  }

  get isExplorer11() {
    const satisfiesSettings = {
      ie:      '>=11.0'
    };
    return this.instance.satisfies(satisfiesSettings);
  }
}

export default new BrowserDetector();
